import { ICustomIconProps } from './types';

const IconAeroplaneSquare: React.FC<ICustomIconProps> = ({ size = 20, color = '#ffffff' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.3595 19.0002L12.0395 17.5802C12.2895 17.3702 12.7095 17.3702 12.9695 17.5802L14.6395 19.0002C15.0295 19.2002 15.5095 19.0002 15.6495 18.5802L15.9695 17.6202C16.0495 17.3902 15.9695 17.0502 15.7995 16.8802L14.1595 15.2302C14.0395 15.1102 13.9495 14.8802 13.9495 14.7202V12.8702C13.9495 12.4502 14.2595 12.2502 14.6495 12.4102L17.9995 13.8502C18.5495 14.0902 19.0095 13.7902 19.0095 13.1902V12.2602C19.0095 11.7802 18.6495 11.2202 18.1995 11.0302L14.2595 9.33023C14.0895 9.26023 13.9595 9.05023 13.9595 8.87023V6.80023C13.9595 6.12023 13.4595 5.32023 12.8595 5.01023C12.6395 4.90023 12.3895 4.90023 12.1695 5.01023C11.5595 5.31023 11.0695 6.12023 11.0695 6.80023V8.87023C11.0695 9.05023 10.9295 9.26023 10.7695 9.33023L6.82953 11.0302C6.38953 11.2202 6.01953 11.7802 6.01953 12.2602V13.1902C6.01953 13.7902 6.46953 14.0902 7.02953 13.8502L10.3795 12.4102C10.7595 12.2402 11.0795 12.4502 11.0795 12.8702V14.7202C11.0795 14.8902 10.9795 15.1202 10.8695 15.2302L9.19953 16.8702C9.02953 17.0402 8.94953 17.3802 9.02953 17.6102L9.34953 18.5702C9.48953 19.0002 9.95953 19.2002 10.3595 19.0002Z'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.5 22H15.5C20.5 22 22.5 20 22.5 15V9C22.5 4 20.5 2 15.5 2H9.5C4.5 2 2.5 4 2.5 9V15C2.5 20 4.5 22 9.5 22Z'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default IconAeroplaneSquare;
